export const environment = {
  //Debug
  // apiUrl: 'http://localhost:32203/api',
  // signalRUrl: 'http://localhost:32203',

  //DEV
  // apiUrl: "http://10.68.216.54:4106/api",
  // signalRUrl: "http://10.68.216.54:4106",

  //PREPROD
  apiUrl: process.env.REACT_APP_API_URL,
  signalRUrl: process.env.REACT_APP_SIGNAL_URL,

  //PROD
  // apiUrl: 'https://webapimyexpenses.msctr.com/api',
  //signalRUrl: 'https://webapimyexpenses.msctr.com'
};
